// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".w-screen-loader{position:fixed;top:0;right:0;bottom:0;left:0;z-index:9}.w-screen-loader--absolute{position:absolute}.w-screen-loader__text,.w-screen-loader__text__title{display:flex;align-items:center}.w-screen-loader__text__title{text-align:left}", ""]);
// Exports
module.exports = exports;
